import axios from 'axios';

const Client = axios.create();

// Client.defaults.baseURL = 'http://localhost:8706/';
Client.defaults.baseURL = 'https://capi.mlab.kr/';
// Client.defaults.headers.common['Authorization'] = 'Bearer a1b2c3d4';

// Client.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (error.response.status === 404) {
//       alert('페이지를 찾을 수 없습니다.');
//     } else if (error.response.data) {
//       alert(error.response.data);
//     }
//     return Promise.reject(error);
//   }
// );

export default Client;
